import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgWeb = function SvgWeb(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.5 6C11.149 6 6 11.149 6 17.5S11.149 29 17.5 29 29 23.851 29 17.5 23.851 6 17.5 6Zm-6.856 11.5c0-.603.078-1.187.224-1.744h3.298a15.282 15.282 0 0 0 0 3.488h-3.298a6.87 6.87 0 0 1-.224-1.744Zm5.046 0c0-.585.037-1.168.111-1.744H19.2a13.678 13.678 0 0 1 0 3.488H15.8a13.678 13.678 0 0 1-.111-1.744Zm3.2 3.368h-2.78c.305 1.197.771 2.352 1.39 3.43a13.673 13.673 0 0 0 1.39-3.43Zm.559 3.207c.488-1.026.86-2.102 1.11-3.207h2.914a6.874 6.874 0 0 1-4.024 3.207Zm-1.624 1.899a.816.816 0 0 0 .288-.016 8.48 8.48 0 0 0 0-16.916.814.814 0 0 0-.288-.016 8.632 8.632 0 0 0-.65 0 .814.814 0 0 0-.288.016 8.48 8.48 0 0 0 0 16.916.816.816 0 0 0 .288.016 8.766 8.766 0 0 0 .65 0ZM17.5 10.7a13.673 13.673 0 0 0-1.39 3.431h2.78a13.673 13.673 0 0 0-1.39-3.43Zm3.334 5.055h3.298a6.87 6.87 0 0 1 .224 1.744 6.87 6.87 0 0 1-.224 1.744h-3.298a15.282 15.282 0 0 0 0-3.488Zm-.275-1.624a15.297 15.297 0 0 0-1.11-3.207 6.873 6.873 0 0 1 4.024 3.207H20.56Zm-9.032 6.736h2.914c.25 1.105.622 2.181 1.11 3.207a6.873 6.873 0 0 1-4.024-3.207Zm0-6.736a6.873 6.873 0 0 1 4.024-3.207 15.297 15.297 0 0 0-1.11 3.207h-2.914Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgWeb;